import { makeStyles } from '@policygenius/mortar';

export default makeStyles((theme) => ({
  bodyText: {
    margin: [theme.spacing('medium'), 0],
  },
  list: {
    listStyle: 'initial',
    listStylePosition: 'inside',
    marginBottom: theme.spacing('medium'),
  },
  listItem: {
    marginBottom: theme.spacing('medium'),
  },
  image: {
    width: '100%',
  },
}));
